"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const InfinityScrollStyled = styled_components_1.default.div `
	transform: translateY(-1px);
`;
function useIntersectionObserver(callback) {
    const observer = (0, react_1.useRef)(new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting)
                callback();
        });
    }, {
        threshold: 0.01,
    }));
    const observe = element => {
        if (!element)
            return;
        observer.current && observer.current.observe(element);
    };
    const unobserve = element => {
        if (!element)
            return;
        observer.current && observer.current.unobserve(element);
    };
    return [observe, unobserve];
}
const InfinityScroll = react_1.default.memo(({ page, data, totalCount, handlerMoreData }) => {
    const target = react_1.default.useRef(null);
    const [observe, unobserve] = useIntersectionObserver(() => handlerMoreData && handlerMoreData(page + 1));
    const [more, setMore] = (0, react_1.useState)('More');
    (0, react_1.useEffect)(() => {
        if (page === 0)
            observe(target.current);
        const N = data.length;
        if (0 === N || totalCount <= N) {
            unobserve(target.current);
        }
        if (totalCount <= N) {
            setMore(null);
        }
    }, [data, page, totalCount, observe, unobserve]);
    return react_1.default.createElement(InfinityScrollStyled, { ref: target }, " ");
});
exports.default = InfinityScroll;
